import React from 'react'

export default function Step1RightContent () {
  return (
    <>
      <div className="title title--h4">Tilmelding til Premium kurser</div>
      <div className="signup-modal__content-text wysiwyg">Premium kurser er vores eksklusive kurser med undervisning på små hold.
        Undervisning med mulighed for at inkludere opgaver og udfordringer fra
        din egen hverdag. Der er gratis materialer og fuld forplejning med bl.a.
        frokost fra Køknets lækre buffet med kolde og varme retter.
      </div>
      <div className="title title--h6">Hvem skal betale for kurset?</div>
      <div className="content-columns content-columns--count-3">
        <div className="content-columns__column">
          <div className="title title--h7">Ledig</div>
          <div className="wysiwyg wysiwyg--fs14">Som ledig har du mulighed for at dit jobcenter
            betaler dele af eller hele
            dit kursus.
            Tal med dit jobcenter om
            mulighederne inden du
            tilmelder dig.</div>
        </div>
        <span className="content-columns__separator"></span>
        <div className="content-columns__column">
          <div className="title title--h7">I job</div>
          <div className="wysiwyg wysiwyg--fs14">Som medarbejder kan
            du vælge selv at betale
            dit kursus eller lave
            en aftale om, at din
            arbejdsplads betaler.</div>
        </div>
        <span className="content-columns__separator"></span>
        <div className="content-columns__column">
          <div className="title title--h7">Arbejdsgiver</div>
          <div className="wysiwyg wysiwyg--fs14">Du kan som arbejdsgiver
            tilmelde en eller flere
            medarbejdere. Du skal
            have medarbejdernes
            CPR-nr. klar for at kunne tilmelde dem.</div>
        </div>
      </div>
    </>
  )
}